import { call, put, takeLatest } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

// `by: 'public'` takes the creator's profile uuid, `by: 'custom'` the brand's encrypted uuid.
// by_public_id returns the global part with the brand part under `brand_stats`;
// by_custom_id returns the brand part with the global part under `global_stats`.
const normalize = (by, result) => {
  if (by === 'public') {
    const { brand_stats: brand = null, ...global } = result;

    return { global, brand };
  }

  const { global_stats: global = null, ...brand } = result;

  return { global, brand };
};

function* getCreatorSignals({ payload: { by, id, signal } }) {
  const endpoint = by === 'public' ? api.creator_object.signals_public : api.creator_object.signals_custom;

  try {
    const { data } = yield call(fetch, { api: endpoint, id, signal });

    yield put(actions.getCreatorSignalsDone(normalize(by, data.result)));
  } catch (error) {
    // 404 = creator outside the signals population (or brand without signals): a normal "no data" state
    yield handleErrors({
      error,
      putErrorData: actions.getCreatorSignalsFailed,
      suppressCriticalErrors: [404],
      endpoint: endpoint.url
    });
  }
}

export const getCreatorSignalsSaga = takeLatest(types.GET_CREATOR_SIGNALS_REQUEST, getCreatorSignals);
